import { Button, Result } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

/**
 * 쿼리 에러 표준 컴포넌트 — 자산관리/투자 전 페이지 공통 (2026-08-18 리뷰 P1 #1)
 * 사용: {q.isError ? <QueryError onRetry={() => q.refetch()} /> : ...}
 * 에러 메시지는 FastAPI 3형태(detail 문자열/배열/message) 파싱.
 */
const extractErrMsg = (e: unknown): string => {
  const err = e as { response?: { data?: { detail?: unknown; message?: string } }; message?: string };
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length && typeof d[0]?.msg === "string") return d[0].msg;
  return err?.response?.data?.message ?? err?.message ?? "알 수 없는 오류";
};

export const QueryError = ({ error, onRetry, compact }: { error?: unknown; onRetry?: () => void; compact?: boolean }) => (
  <Result
    status="warning"
    title={compact ? "데이터를 불러오지 못했어요" : "데이터를 불러오지 못했어요"}
    subTitle={error ? extractErrMsg(error) : "잠시 후 다시 시도해주세요."}
    extra={
      onRetry && (
        <Button size="small" icon={<ReloadOutlined />} onClick={onRetry}>
          다시 시도
        </Button>
      )
    }
    style={{ padding: compact ? "24px 0" : "48px 0" }}
  />
);

export default QueryError;
